import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/nunito-variable-latin.css';
import './styles/brand-tokens.css';
import './index.css';

document.getElementById('seo-prerender')?.setAttribute('hidden', '');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enregistrement du Service Worker en production uniquement
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) => {
        if (import.meta.env.DEV) {
          // eslint-disable-next-line no-console
          console.warn('[SW] Enregistrement échoué :', err);
        }
      });
  });
}
